/* eslint-disable max-len */
export const userInviteMessages = {
    'Users.invite': 'Invite to Auvik SaaS Management',
    'Users.invite.emailBody':
        '<p style="color:{{colorText}}; text-decoration: none;">Click the link below and log in with the username below to get started!<br /><br /><span style="color: {{colorHighlight}}; font-weight: 600;">Your username: </span><a href="" style="color: {{colorEmail}}; text-decoration: none">{{email}}</a>.</p>',
    'Users.invite.emailContactUs':
        '<span style="font-weight:600;">Questions?</span> Reach out to the person who invited you to Auvik SaaS Management at <a href="mailto:{{email}}" style="color: {{colorEmail}}; text-decoration: none !important">{{email}}</a> or contact us at <a href="mailto:support@auvik.com" style="color: {{colorEmail}}; text-decoration: none">support@auvik.com</a>.',
    'Users.invite.emailFail': 'Unable to send welcome emails to {{emails}}.',
    'Users.invite.emailIntro':
        'You’ve been invited to Auvik SaaS Management - A SaaS security and monitoring platform to protect your users from the risks of Shadow IT.',
    'Users.invite.emailSubject':
        'Welcome to Auvik SaaS Management Powered by {{name}}',
    'Users.invite.invitationFail': 'Unable to send invitations.',
    'Users.invite.successSent': 'The invitations have been sent.'
};
